module.exports = __webpack_public_path__ + "static/media/Frame 3000.0ac6dcd3.svg";